import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api/api.service';
import { FlashService } from '@app/services/flash.service';
import {
  FollowAddArrival,
  FollowAddArrivalFail,
  FollowAddArrivalSuccess,
  FollowArrivalActionTypes,
  FollowArrivalDelete,
  FollowArrivalDeleteFail,
  FollowArrivalUpdate,
  FollowArrivalUpdateFail,
  FollowArrivalUpdateSuccess,
  Load,
  LoadFail,
  LoadSuccess
} from '@core/actions/follow-arrivals.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class FollowArrivalEffects {
  constructor(
    private actions$: Actions,
    private api: ApiService,
    private fs: FlashService
  ) {}

  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType<Load>(FollowArrivalActionTypes.Load),
    map(action => action.FollowId),
    switchMap(FollowId => {
      return this.api.getFollowArrivals(FollowId).pipe(
        map((followArrivals: any[]) => new LoadSuccess(followArrivals)),
        catchError(error => of(new LoadFail(error)))
      );
    })
  );

  @Effect()
  followAddArrival$: Observable<Action> = this.actions$.pipe(
    ofType<FollowAddArrival>(FollowArrivalActionTypes.FollowAddArrival),
    map(action => [action.data]),
    switchMap(([data]) => {
      return this.api.addFollowArrival(data).pipe(
        map((arrival: any) => new FollowAddArrivalSuccess(arrival)),
        catchError(error => of(new FollowAddArrivalFail(error)))
      );
    })
  );

  @Effect()
  update$: Observable<Action> = this.actions$.pipe(
    ofType<FollowArrivalUpdate>(FollowArrivalActionTypes.FollowArrivalUpdate),
    map(action => [action.data]),
    switchMap(([data]) => {
      return this.api.updateFollowArrival(data).pipe(
        map((arrival: any) => new FollowArrivalUpdateSuccess(arrival)),
        catchError(error => of(new FollowArrivalUpdateFail(error)))
      );
    })
  );

  @Effect()
  followArrivalDelete$: Observable<Action> = this.actions$.pipe(
    ofType<FollowArrivalDelete>(FollowArrivalActionTypes.FollowArrivalDelete),
    map(action => [action.FollowId, action.arrivalId]),
    switchMap(([FollowId, arrivalId]) => {
      return this.api.deleteFollowArrival(FollowId, arrivalId).pipe(
        map((arrivals: any) => new Load(FollowId)),
        catchError(error => {
          console.log('ERROR ->', error);
          return of(new FollowArrivalDeleteFail(error));
        })
      );
    })
  );

  @Effect({ dispatch: false })
  followArrivalDeleteFail$: Observable<void> = this.actions$.pipe(
    ofType<FollowArrivalDeleteFail>(
      FollowArrivalActionTypes.FollowArrivalDeleteFail
    ),
    map(action => {
      this.fs.emit({ type: 'danger', message: 'Error al eliminar arribo' });
    })
  );
}
